export default {"src":"/_next/static/media/app-store_badge_es.284e30b6.svg","height":40,"width":120};